import { fillArr, getByOrder } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';
import { getCoinsMock } from '@kr/store';

export function getWalletMock(i: number): WalletCard {
  const coins = getCoinsMock();

  return {
    id: String(i),
    name: `Crypto${i}`,
    balanceAvailable: `${i * 10}204056.077`,
    networkBalance: `${i * 10}5.077`,
    coinId: getByOrder(i, coins).id,
    secondaryWalletCoinId: +getByOrder(i, coins).id + 1,
    coin: getByOrder(i, coins),
    secondaryWalletCoin: getByOrder(i + 1, coins),
    address: '0x2BFf94f8c712Ba8F71B54069A1eD1779f3E9Ad22',
    active: true,
    organizationType: Math.random() < 0.5 ? 'BASE' : 'ALT',
    organizationId: i,
    orgId: i,
  };
}

export function getWalletsMock(count = 13): WalletCard[] {
  return fillArr(count, i => getWalletMock(i));
}
